let $themeButtons = document.querySelectorAll('.back__inicio');
    
    $themeButtons.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelector('body').classList.add('out-animation');
            setTimeout(() => {
                location.href = '/'
            }, 1000);
        })
    });